import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import CTABand from "../components/resource/CTABand";
import { container, item, inView } from "../components/service/presets";
import { ArrowRight } from "lucide-react";

export default function Platforms() {
  const { t, dir } = useLang();
  const flip = dir === "rtl" ? "scaleX(-1)" : "none";
  const items = t.platforms.items;

  return (
    <div>
      <PageHero tag={t.res.platTag} title={t.res.platTitle} desc={t.res.platDesc} />
      <section className="py-12 rq-light">
        <motion.div {...inView} variants={container} className="rq-container grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((p, i) => {
            const inner = (
              <>
                <div className="flex items-center justify-between">
                  <div className="h-16 w-16 rounded-2xl overflow-hidden ring-1 ring-white/10 shadow-lg shrink-0">
                    <img src={p.logo} alt={p.name} loading="lazy" className="h-full w-full object-cover" />
                  </div>
                  {p.slug && (
                    <span className="grid place-items-center h-9 w-9 rounded-full bg-[rgba(14,122,58,0.12)] text-[color:var(--rq-green)] transition-transform duration-300 group-hover:scale-110">
                      <ArrowRight size={16} style={{ transform: flip }} />
                    </span>
                  )}
                </div>
                <div className="font-display mt-4 text-xl font-bold text-white">{p.name}</div>
                <p className="mt-2 text-sm leading-relaxed text-[color:var(--rq-muted)]">{p.desc}</p>
                {p.slug && (
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--rq-green)]">
                    {t.res.learnMore}
                    <ArrowRight size={14} style={{ transform: flip }} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                )}
              </>
            );
            return (
              <motion.div key={i} variants={item} whileHover={p.slug ? { y: -6 } : undefined}>
                {p.slug ? (
                  <Link to={`/platforms/${p.slug}`} className="rq-card p-7 h-full block group hover:border-[rgba(14,122,58,0.4)]" data-testid={`platform-card-${p.slug}`}>
                    {inner}
                  </Link>
                ) : (
                  <div className="rq-card p-7 h-full">{inner}</div>
                )}
              </motion.div>
            );
          })}
        </motion.div>
      </section>
      <CTABand />
    </div>
  );
}
